import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b4c9228c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4c9228c')) {
      api.createRecord('b4c9228c', component.options)
    } else {
      api.reload('b4c9228c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b4c9228c&", function () {
      api.rerender('b4c9228c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/roles/index.vue"
export default component.exports